import { useEffect, useState } from "react";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, { animationCleanUp } from "./animation";
import assets from "./assets";
import "./style/style.scss";
import "./style/animation.scss";
import getContentById from "../../../../shared/utils/getContentById";
import parseMediaUrl from "../../../../shared/functions/parseMediaUrl";
import TeamLogo from "../../_partials/TeamLogo";
import textImage from "./images/mainText_v.webp";
import textImageWhite from "./images/mainText_white.webp";
import textImageGray from "./images/mainText_gray.webp";
import textImageGray916 from "./images/mainText_gray-9-16.webp";
import textImageWhite916 from "./images/mainText_white_9-16.webp";
import _ from "lodash";
import Functions from "../../../../shared/components/MediaLibrary/EditModal/functions";
import {
  getWrapperDimensions,
  getImageFilterStyle,
} from "../../../../shared/components/MediaLibrary/EditModal/ImageEditorModal";
import { getScaleSize } from "../../fcb/Lineup/Index";
import { ratioFromFormat } from "../ResultsNew/Index";
import { GKPresetColors } from "../../../../shared/components/MediaLibrary/EditModal/LeftSidebar/EditTab";
import { DEFAULT_ADJUSTMENTS } from "../../../constants/constants";
import { uefaID } from "../ImageTable/Index";
import {
  DEFAULT_PRESET_COLOR,
  getPresetClass,
  getSavedPresetColor,
} from "./preset";

const getMainBackground = (format) => {
  if (format === "1200x1500") {
    return _.get(assets, `mainbackground_1200`);
  }

  if (format === "1080x1920") {
    return _.get(assets, `mainbackground_1080`);
  }
};

const PlayerCard = ({ player, presetClass, gkPreset, index, isSubstitute = false, lang = 'en' }) => {
  const hasPlayer = !!player;
  return (
    <div
      className={`player-card ${isSubstitute ? "substitute-card" : "main-card"} ${lang === 'ar' ? "player-ar" : ""}`}
    >
      <div className="player-info">
        <div className="jersey-number">
          <div className="jersey-number">
            <div>{hasPlayer ? player?.shirtNumber : ""}</div>
            {hasPlayer ? (
              <span className="outline_no">{player?.shirtNumber}</span>
            ) : null}
          </div>
        </div>
        <div className="player-name">
          {hasPlayer
            ? lang === "ar" ? player?.arabicName : player?.shortLastName?.toUpperCase() || player?.label?.toUpperCase() : ""}
        </div>
      </div>
    </div>
  );
};


export const reorderPlayers = (players) => {
  const goalkeepers = players.filter(p => p?.position === "Goalkeeper");
  const others = players.filter(p => p?.position !== "Goalkeeper");
  return [...goalkeepers, ...others];
}

const Index = ({ animation, data, mode, format, _searchParams, ...props }) => {
  const presetBgColor = props.presetBgColor;
  const presetGkColor = props.presetGkColor;
  const templateName = data?.template_name ?? "";
  const id = `${templateName}_${data?.uuid}`;
  const manualEntries = props.manualEntries;

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };
  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          id,
          data,
          format,
          apiSetup: props?.apiSetup,
          templateName: data?.template_name,
        });
      }
    }

    if (mode === "screenshot") {
      const videoBg = $(`#${id} video.custom-background`).get(0);
      if (videoBg) {
        videoBg.addEventListener(
          "loadedmetadata",
          function () {
            this.currentTime = 3;
            this.pause();
          },
          false,
        );
      }
    }

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const { fields, dynamic, editData } = data?.data || {};
  const _initialLayers = editData?.layers;

  const { teamSide } = data?.data?.dynamic || {};

  const liveLineup = _.get(dynamic, "lineup");

  const customLineupPlayers = getContentById("lineup_players", fields);
  const customLineupPlayersData = getContentById(
    "lineup_players",
    fields,
    "data",
  );
  // manualEntries first so an edited player (same id, reused when editing an
  // existing squad player) overrides its original squad-data counterpart
  // instead of both rendering side by side.
  const customLineup = _.unionBy(manualEntries, customLineupPlayersData, "id")?.filter((player) =>
    customLineupPlayers.includes(player?.id),
  );
  const customAdditionalLineup = getContentById("additional_lineup", fields);
  customAdditionalLineup?.map((element) => {
    if (element) {
      customLineup.push({
        shirtNumber: element.shirtNumber,
        label: element.label,
      });
    }
  });

  const sortedCustomLineup = [...customLineup];
  sortedCustomLineup.sort((a, b) => a.shirtNumber - b.shirtNumber);

  const customReservePlayers = getContentById("reserve_players", fields);
  const customReservePlayersData = getContentById(
    "reserve_players",
    fields,
    "data",
  );
  const customReserve = _.unionBy(manualEntries, customReservePlayersData, "id")?.filter((player) =>
    customReservePlayers?.includes(player?.id),
  );
  const customAdditionalReserve = getContentById("additional_reserve", fields);
  customAdditionalReserve?.map((element) => {
    if (element) {
      customReserve.push({
        shirtNumber: element.shirtNumber,
        label: element.label,
      });
    }
  });

  const imageSide = getContentById("imageSide", fields) || "left";
  const homeTeam = data?.event?.home;
  const awayTeam = data?.event?.away;
  const competitionId = data?.event?.competitionId;

  const fcbTeam = homeTeam?.id === "apoawtpvac4zqlancmvw4nk4o" ? homeTeam : awayTeam;

  const liveLineupData =
    teamSide === "home"
      ? _.find(liveLineup, { contestantId: homeTeam?.id })
      : _.find(liveLineup, { contestantId: awayTeam?.id });

  const sortedLiveLineupData = liveLineupData;
  sortedLiveLineupData?.player.sort((a, b) => a.shirtNumber - b.shirtNumber);

  const customBackground = getContentById("background", fields, "self");
  const customBackgroundStyles = _.get(
    customBackground,
    `styles.${format}`,
    {},
  );
  const [layers, setLayers] = useState([]);
  // When the image editor drives this preview it owns the background layers, so
  // they arrive as a prop and take precedence over anything stored on the
  // template -- that is what makes an edit to the background show up here right
  // away instead of only after a save. It is undefined everywhere else (the
  // screenshot/export render), where the stored layers below are used.
  const liveLayers = props?.liveLayers;
  // Mirrors Index.jsx so the editor preview and the exported template place a
  // background picture identically.
  const prevRatio = props?.prevRatio;
  const [ratioSize, setRatioSize] = useState({ width: 4.075, height: 4.075 });

  useEffect(() => {
    if (prevRatio) {
      setRatioSize(getScaleSize(format, prevRatio));
    } else if (data?.data?.editData) {
      setRatioSize(getScaleSize(format, ratioFromFormat(data.currentFormat)));
    } else {
      setRatioSize(getScaleSize(format, 0));
    }
  }, [format, prevRatio]);
  const defaultEffects = {
    isBlur: false,
    isOpacity: false,
    isGradient: false,
    isShadow: false,
    resize: 100,
    ratio: 0,
    ratioUrl: "",
    prevRatio: 0,
    gkPreset: GKPresetColors.red,
    includeSmiling: false,
  };
  const [effects, setEffects] = useState(defaultEffects);

  useEffect(() => {
    if (liveLayers) {
      setLayers(liveLayers);
    }
  }, [liveLayers]);

  useEffect(() => {
    if (liveLayers) return;
    const initialLayers = editData?.layers;
    const initialEffects = editData?.effects;

    if (initialLayers) {
      setTimeout(() => {
        setLayers(initialLayers);
        setEffects(initialEffects ?? effects);
        if (initialEffects?.ratio > 0) {
          // prevRatioRef.current = initialEffects?.ratio;
        }
        // 100ms, as the published template always used: this branch only runs
        // there -- the editor canvas and the save preview pass `liveLayers` and
        // return above -- and the screenshot is taken on a timer.
      }, 100);
    }
    if (!initialLayers && !editData) {
      const getBackgroundUrls = () => {
        const background = getContentById("background", fields, "self");
        const values = background?.value;
        if (!Array.isArray(values)) return [];

        return values.map((val) => parseMediaUrl(_.get(val, "url", "")));
      };
      const backgroundUrls = getBackgroundUrls();
      const initializeLayers = async () => {
        const newLayerPromises = backgroundUrls.map(async (url, index) => {
          const functions = new Functions(url);
          const finalUrl = functions.getUrl();
          const newDimension = getWrapperDimensions(effects.ratio);
          const newLayer = {
            id: Date.now() + index,
            imageUrl: finalUrl,
            backgroundUrl: url,
            functions,
            dimensions: {
              width: newDimension.width,
              height: newDimension.height,
            },
            originalDimensions: {
              width: newDimension.width,
              height: newDimension.height,
            },
            nonRatioDimensions: {
              width: newDimension.width,
              height: newDimension.height,
            },
            adjustments: DEFAULT_ADJUSTMENTS,
            x: 0,
            y: 0,
            nonRatioX: 0,
            nonRatioY: 0,
            zIndex: index + 1,
            backgroundAndResize: {
              removebg: false,
              removebgUrl: "",
              changebg: false,
              changebgUrl: "",
            },
            isResizing: false,
            isRecreated: false,
          };

          return newLayer;
        });

        const addedLayers = await Promise.all(newLayerPromises);

        setLayers(addedLayers);
        setEffects(defaultEffects);
      };
      initializeLayers();
    }
  }, [editData, fields, liveLayers]);

  const hasUserSelection = Array.isArray(customLineupPlayers) && customLineupPlayers !== null;
  const mainPlayers = hasUserSelection
    ? sortedCustomLineup
    : [];

  const substitutePlayers =
    customReserve?.length > 0
      ? customReserve
      : [] ||
      [];

  const keepersFromSub = substitutePlayers.filter((p) => p.position === 'Goalkeeper');
  const excludeKeepersFromSub = substitutePlayers.filter((p) => p.position !== 'Goalkeeper');
  excludeKeepersFromSub?.sort((a, b) => a.shirtNumber - b.shirtNumber);

  let normalizedPlayers = [...mainPlayers];
  while (normalizedPlayers.length < 11) {
    normalizedPlayers.push(null);
  }
  normalizedPlayers = reorderPlayers(normalizedPlayers);

  // Derived, not state: the jersey is fully determined by what the caller passes
  // and the layers it was saved with, so it is correct from the first render --
  // no effect to wait on, and nothing that can overwrite it after a timeout.
  // The editor always passes `presetBgColor`; the published template passes the
  // one recovered from the saved layers (see Index.jsx).
  const presetClass = getPresetClass(
    presetBgColor || getSavedPresetColor(layers) || DEFAULT_PRESET_COLOR,
  );
  const templateLang = data.lang;
  const isUEFA = data?.event?.competitionId === uefaID;
  return (
    <div
      id={id}
      className={`T_womens_lineup ${presetClass} ${animation ? "animation" : ""} newTemplate image-side-${imageSide}`}
    >
      <TemplateBlock>
        {/* The DFB Pokal version keeps the CL-stars styling — only its background
            differs — so `no-cl` must stay off whenever the Pokal artwork is on. */}
        <div className={`custom-background-container ${props.hasCLStars || props.isDfbPokal ? "" : "no-cl"} ${props.isDfbPokal ? "pokal" : ""}`}>
          <div
            id={_.get(customBackground, "id", null)}
            style={{ ...customBackgroundStyles }}
            className={"custom-background"}
          >
            {layers.map((layer) => {
              const { id: layerId, adjustments, imageUrl, dimensions, x, y } = layer;
              const { colorOverlays = [], ...filterStyle } = getImageFilterStyle(adjustments);
              return (
                <div
                  style={{
                    position: "absolute",
                    width: `${dimensions.width * ratioSize.width}px`,
                    height: `${dimensions.height * ratioSize.height}px`,
                    left: `${x * ratioSize.width}px`,
                    top: `${y * ratioSize.height}px`,
                    ...filterStyle,
                  }}
                  className="image-wrapper"
                  key={layerId}
                >
                  <img
                    src={imageUrl}
                    style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "top" }}
                  />

                  {colorOverlays.map((overlayStyle, i) => (
                    <div
                      key={i}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        pointerEvents: "none",
                        ...overlayStyle,
                      }}
                    />
                  ))}
                </div>
              );
            })}
          </div>
        </div>

        <div className={`mainCard-content ${props.hasCLStars || props.isDfbPokal ? "" : "no-cl"}`}>
          <div className="mainCard-content-text">
          </div>
          <div className={`wc-content content`} style={{ zIndex: 101 }}>
            {/* Main Lineup Section */}
            <div className="lineup-section">
              <div className="lineup-section-heading">
                {/* Team Logos */}
                <div className={`logo-container`}>
                  <div className={`home`}>
                    <TeamLogo team={homeTeam} competitionId={competitionId} />
                  </div>
                  <div className={`away`}>
                    <TeamLogo team={awayTeam} competitionId={competitionId} />
                  </div>
                </div>
                <div className="lineup-title">
                  <div>XI</div>
                  <span class="outlineText">XI</span>
                </div>
              </div>
              {/* <div className="main-players-grid"> */}
              {normalizedPlayers?.map((player, index) => (
                <PlayerCard
                  key={`player-slot-${index}-${player?.id || "empty"}`}
                  player={player}
                  presetClass={presetClass}
                  index={index}
                  gkPreset={presetGkColor}
                  lang={templateLang}
                />
              ))}
              {/* </div> */}
            </div>

            {/* Substitutes Section */}
            {substitutePlayers.length > 0 && (
              <div className="substitutes-section">
                <div className={`substitutes-list ${templateLang === 'ar' ? "substitues-ar" : ""}`}>
                  {keepersFromSub.map((player, index) => (
                    <span
                      key={`sub-${player?.shirtNumber || index}`}
                      className="substitute-name"
                    >
                      {templateLang === 'ar' ? player?.arabicName : player?.shortLastName?.toUpperCase() || player?.label?.toUpperCase()}
                      <span className="substitute-comma">
                        {index < keepersFromSub.length - 1 && (templateLang === 'ar' ? "، " : ", ")}
                      </span>
                    </span>
                  ))}
                  {keepersFromSub.length > 0 ? <span> - </span> : <span />}
                  {excludeKeepersFromSub?.map((player, index) => (
                    <span
                      key={`sub-${player?.shirtNumber || index}`}
                      className="substitute-name"
                    >
                      {templateLang === 'ar' ? player?.arabicName : player?.shortLastName?.toUpperCase() || player?.label?.toUpperCase()}
                      <span className="substitute-comma">
                        {index < excludeKeepersFromSub.length - 1 && (templateLang === 'ar' ? "، " : ", ")}
                      </span>
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </TemplateBlock>
    </div>
  );
};

export default Index;
